export const FONT_SANS =
  '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", "PingFang SC", "Microsoft YaHei", system-ui, sans-serif';

/** Brand hero style — Mapbox Studio (Standard import + Sydney camera). Requires mapbox-gl ≥ 3.21. */
export const MAPBOX_STYLE_PATH = 'cahunter/cm3p9azqv000701sne3rn1b4c';
export const MAPBOX_STYLE = `mapbox://styles/${MAPBOX_STYLE_PATH}`;

export const MAPBOX_HERO_VIEW = {
  center: [151.211084, -33.856471],
  zoom: 15.99,
  pitch: 71,
  bearing: -172,
};

export function getMapboxAccessToken() {
  return (process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || '').trim();
}

/** @deprecated iframe embed — prefer mapbox-gl in MapHero */
export function getMapEmbedUrl() {
  const token = getMapboxAccessToken();
  const params = new URLSearchParams({
    title: 'false',
    access_token: token,
    zoomwheel: 'false',
  });
  return `https://api.mapbox.com/styles/v1/${MAPBOX_STYLE_PATH}.html?${params.toString()}#15.99/-33.856471/151.211084/188/71`;
}

export const BUILD_PROGRESS_TARGET = 88;

export const SOCIAL_LINKS = [
  { href: 'https://t.me/yourlink', label: 'Telegram', icon: 'telegram' },
];

/** Feature screenshots in `public/img/` — `- EN` / `- CN` suffix per locale where available. */
export const FEATURE_MEDIA = {
  treasureHunt: {
    en: ['/img/Treasure - EN.png', '/img/coupon - EN.png'],
    zh: ['/img/Treasure - CN.png', '/img/coupon - CN.png'],
  },
  checkins: {
    en: [
      '/img/locationsharego.png',
      '/img/locationsharemap.png',
      '/img/locationsharegathering.png',
      '/img/locationsharefilter.png',
    ],
    zh: [
      '/img/locationsharego.png',
      '/img/locationsharemap.png',
      '/img/locationsharegathering.png',
      '/img/locationsharefilter.png',
    ],
  },
  offlineMaps: {
    en: '/img/Outdoor - EN.png',
    zh: '/img/Outdoor - CN.png',
  },
  cityWalk: {
    en: '/img/citywalk - EN.png',
    zh: '/img/citywalk - CN.png',
  },
  events: {
    en: ['/img/event - EN.png', '/img/ainotifier.png'],
    zh: ['/img/event - CN.png', '/img/ainotifier.png'],
  },
  aiPlanner: {
    en: '/img/aiplanner.png',
    zh: '/img/aiplanner.png',
  },
  premium: {
    en: ['/img/sos.png', '/img/sosbroadcast.png', '/img/emergencycontact.png'],
    zh: ['/img/sos.png', '/img/sosbroadcast.png', '/img/emergencycontact.png'],
  },
};

/** @deprecated Use FEATURE_MEDIA with language — kept for legacy single-path slots. */
export const MEDIA = {
  treasureHunt: null,
  checkins: null,
  offlineMaps: null,
  cityWalk: null,
  events: null,
  premium: null,
};

export const FEATURE_LAYOUT = [
  { id: 'events', mediaKey: 'events', reverse: false, couponTier: 'medium' },
  { id: 'ai-planner', mediaKey: 'aiPlanner', reverse: true, couponTier: 'epic' },
  { id: 'checkins', mediaKey: 'checkins', reverse: false, couponTier: 'medium' },
  { id: 'offline-maps', mediaKey: 'offlineMaps', reverse: true, couponTier: 'epic' },
  { id: 'city-walk', mediaKey: 'cityWalk', reverse: false, couponTier: 'normal' },
  { id: 'treasure-hunt', mediaKey: 'treasureHunt', reverse: true, couponTier: 'normal', linkTo: '/support' },
  {
    id: 'premium',
    mediaKey: 'premium',
    reverse: false,
    couponTier: 'epic',
    linkTo: '/support',
    showLink: true,
  },
];

export const ROADMAP_LAYOUT = [
  { id: 'q2-2026', colorKey: 'accent' },
  { id: 'testflight', colorKey: 'couponMedium' },
  { id: 'app-store', colorKey: 'couponEpic' },
  { id: 'expansion', colorKey: 'primary' },
];

export const fadeInUp = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
  },
};
